import React from 'react';
import {
  DeadlinesWrapper,
  DeadlinesTitle,
  DeadlineList,
  DeadlineCard,
  DeadlineInfo,
  DeadlineName,
  Pill,
  DueDate,
  ViewAllButton,
} from './Deadlines.styles';

const deadlines = [
  { name: 'Graph Theory Problem Set', course: 'MATH 310', date: 'Oct 20, 2024', urgent: true },
  { name: 'Assembly Language Lab', course: 'CS 205', date: 'Oct 22, 2024', urgent: false },
  { name: 'Midterm Project', course: 'CS 301', date: 'Oct 25, 2024', urgent: true },
  { name: 'Research Paper Draft', course: 'ENG 102', date: 'Oct 28, 2024', urgent: false },
];

const Deadlines: React.FC = () => {
  return (
    <DeadlinesWrapper>
      <DeadlinesTitle>
        <span role="img" aria-label="alarm">⏰</span> Upcoming Deadlines
      </DeadlinesTitle>
      <DeadlineList>
        {deadlines.map((d) => (
          <DeadlineCard key={d.name} $urgent={d.urgent}>
            <DeadlineInfo>
              <DeadlineName>
                {d.name}
                <Pill>{d.course}</Pill>
              </DeadlineName>
            </DeadlineInfo>
            <DueDate>{d.date}</DueDate>
          </DeadlineCard>
        ))}
      </DeadlineList>
      <ViewAllButton>View All Assignments</ViewAllButton>
    </DeadlinesWrapper>
  );
};

export default Deadlines;


